import PropTypes from "prop-types";
import Button from "solar/components/Button";
import Photo from "components/shared/stays/Photo";
import styles from "components/shared/stays/MessageButton.module.scss";

export default function MessageButton({
  guidePrimaryEmployeeImageUrl,
  guidePrimaryEmployeeFirstName,
  size = 2,
}) {
  return (
    <Button size={size} variant="black" block>
      <span className={styles.component}>
        {guidePrimaryEmployeeImageUrl && (
          <span className={styles.image}>
            <Photo
              src={guidePrimaryEmployeeImageUrl}
              alt={guidePrimaryEmployeeFirstName}
              width={parseInt(styles.sizeImage, 10)}
              height={parseInt(styles.sizeImage, 10)}
              layout="fixed"
              objectFit="cover"
            />
          </span>
        )}
        <span className={styles.text}>
          {"Message "}
          {guidePrimaryEmployeeFirstName}
        </span>
      </span>
    </Button>
  );
}

MessageButton.propTypes = {
  guidePrimaryEmployeeFirstName: PropTypes.string.isRequired,
  guidePrimaryEmployeeImageUrl: PropTypes.string.isRequired,
  size: PropTypes.number,
};
